import * as React from 'react'
import { Form, Input, InputNumber, Modal } from 'antd'
import { FormInstance } from 'antd/lib/form'

import { TTModalProps } from '../shared/TTModalProps'
import { TTInputCurrency } from '../shared/TTInputCurrency'

interface ModalEditNomeStresstestProps extends TTModalProps {
    value: string,
}

//class ModalAmountState {
//    amount: number
//    variazioneEuro: number
//    variazionePerc: number
//}

export class ModalEditNomeStresstest extends React.Component<ModalEditNomeStresstestProps, any> {

    formRef = React.createRef<FormInstance>()
    //inputRef = React.createRef<HTMLInputElement>()

    //variazioneEuro: number
    //variazionePerc: number

    constructor(props) {
        super(props)
        //let _state = new ModalAmountState()
        //this.state = _state

    }

    componentDidUpdate(prevProps: ModalEditNomeStresstestProps) {
        //if (prevProps.visible == false && this.props.visible == true) {
        //    this.inputRef.current.focus()
        //    this.updateAmount(this.props.value)
        //}

    }

    closeModal = () => {
        this.formRef.current.resetFields()
        this.props.closeModal()
    }

    onSave = async () => {
        try {
            let data = await this.formRef.current.validateFields()

            this.props.do(data.NomeStresstest)
            this.closeModal()
        } catch (err) {
            console.log(err)
        }
    }

   

    render() {
        return (

            <Modal
                destroyOnClose
                title="Inserisci il nome dello stress test"
                visible={this.props.visible}
                onCancel={this.closeModal}
                onOk={this.onSave}>
                <Form ref={this.formRef}>
                    <Form.Item
                        label="Nome stress test"
                        name="NomeStresstest"
                        initialValue={this.props.value}
                         >
                        <Input style={{ width: '40%' }}  />
                    </Form.Item>
                </Form>
            </Modal>
        )
    }
}